import { useEffect, useState } from 'react';
import { useUnifiedAuth } from '@/contexts/auth/UnifiedAuthProvider';
import { queryClient } from '@/lib/query-client';

/**
 * Progressive enablement for queries:
 * - enable as soon as userId exists to permit cold-mount fetch
 * - when full auth conditions are met, trigger a refetch once
 */
export function useProgressiveEnable(userId?: string) {
  const { authSettled, sessionExpired } = useUnifiedAuth();

  const basicEnable = Boolean(userId);
  const fullEnable = Boolean(userId) && authSettled && !sessionExpired;

  const [shouldRefetch, setShouldRefetch] = useState(false);

  useEffect(() => {
    if (basicEnable && !fullEnable) {
      setShouldRefetch(true);
    } else if (fullEnable && shouldRefetch) {
      try {
        queryClient.invalidateQueries();
      } catch {
        // ignore
      } finally {
        setShouldRefetch(false);
      }
    }
  }, [basicEnable, fullEnable, shouldRefetch]);

  return { enable: basicEnable, isFullyReady: fullEnable };
}


